import {lazyComponent} from 'coreUtils/adapters/lazy';

const CMSPopupFactory = lazyComponent(() => import('./CMSPopupFactory'));

export {CMSPopupFactory as default};
